import {Injectable, NgZone} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Select, Store} from '@ngxs/store';
import {AuthenticationService} from '../../service/auth.service';
import {SwalUtil} from '../../util/swal-util';
import {GetAccountStatusAction} from '../../actions/account.actions';
import {combineLatest, Observable} from 'rxjs';
import {map, take} from 'rxjs/operators';
import { GetPartnerAssociatedAction } from 'src/app/actions/user-profile.actions';
import { UserProfileState } from 'src/app/states/user-profile.state';
import { UserProfileApiService } from 'src/app/api/user-profile-api.service';

@Injectable({
  providedIn: 'root'
})
export class AdditionalInformationGuard  {

  constructor(
    protected router: Router, protected store: Store,
    protected authenticationService: AuthenticationService,
    protected ngZone: NgZone, protected swalUtil: SwalUtil,
    protected userProfileApiService: UserProfileApiService,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const status$ = this.store.dispatch(new GetAccountStatusAction);
    const partner$ = this.userProfileApiService.getPartnerAssociated();
    return combineLatest([
      status$,
      partner$
    ]).pipe(
      map(([actionResult, userPartner]) => {
        if (actionResult.account.accountStatus.verificationStatus.informacionAdicional == 'APPROVED'){
          this.showMessage(userPartner);
          return false;
        } else {
          return true;
        }
      })
    )
  }

  private showMessage(partner: any): void {
    const phone = partner ? partner.telefonos[0].phoneNumber : '1164853540';
    SwalUtil.fireGenericMessage('Atención', 'Ya has completado el formulario de Información Adicional. Para más información comunícate con validaciones@mercadocheque.com o envía un mensaje a nuestro Whatsapp: +' + phone).then(value => {
        this.router.navigate(['/home']);
      }
    );
  }

}
